import api from '../../api/axios';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_VALIDATE_SUCCESS = 'AUTH_VALIDATE_SUCCESS';
export const TOKEN_LOGIN_REQUEST = 'TOKEN_LOGIN_REQUEST';
export const TOKEN_LOGIN_SUCCESS = 'TOKEN_LOGIN_SUCCESS';
export const TOKEN_LOGIN_FAILURE = 'TOKEN_LOGIN_FAILURE';

export const validateToken = () => async (dispatch) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }
  try {
    // Validate and receive user + possibly refreshed token
    const response = await api.post(`auth/validatetoken`, null);
    const envelope = response?.data || {};
    const apiPayload = envelope?.data || {};
    const user = apiPayload?.user || null;
    const userpackageinfos = apiPayload?.userpackageinfos || null;
    const refreshedToken = apiPayload?.token || null;

    if (refreshedToken && refreshedToken !== token) {
      localStorage.setItem('token', refreshedToken);
    }

    // Store user (and token if provided) in reducer
    dispatch({
      type: AUTH_VALIDATE_SUCCESS,
      payload: { user, userpackageinfos, token: refreshedToken || token },
    });
    return true;
  } catch (error) {
    // Invalid/expired token
    localStorage.removeItem('token');
    // No need to clear Authorization on instance; it reads token per request
    dispatch({ type: AUTH_LOGOUT });
    return false;
  }
};

export const loginWithToken = (token) => async (dispatch) => {
  dispatch({ type: TOKEN_LOGIN_REQUEST });
  
  try {
    // Set the token in localStorage and axios headers
    localStorage.setItem('token', token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    
    // Validate the token by calling the API
    const response = await api.post(`auth/validatetoken`, null);
    const envelope = response?.data || {};
    const apiPayload = envelope?.data || {};
    const user = apiPayload?.user || null;
    const validatedToken = apiPayload?.token || token;

    // Update token if API returned a refreshed one
    if (validatedToken !== token) {
      localStorage.setItem('token', validatedToken);
      api.defaults.headers.common.Authorization = `Bearer ${validatedToken}`;
    }

    // Dispatch success action
    dispatch({
      type: TOKEN_LOGIN_SUCCESS,
      payload: { user, token: validatedToken },
    });

    return { success: true, user, token: validatedToken };
  } catch (error) {
    // Clear token on failure
    localStorage.removeItem('token');
    delete api.defaults.headers.common.Authorization;
    
    dispatch({
      type: TOKEN_LOGIN_FAILURE,
      error: error.response?.data?.message || 'Invalid token',
    });

    return { success: false, error: error.response?.data?.message || 'Invalid token' };
  }
};
